const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '中标合同信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '合同',
            data: [],
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.getBaseInfo()
        },
        getBaseInfo() {
            const arr = this.form.businessKey.split(':')
            this.$request.post(`/transformToAfter/app/contract/record/getHeTongInfo`, {
                bdGuid: this.form.bdGuid,
                htGuid: arr[1],
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '标段/包名称': res.data.bdName,
                    '标段/包编号': res.data.bdBH,
                    '项目类型': getProjectTypeName(res.data.xmLeiXing),
                    '采购方式': getPurchaseTypeName(res.data.zbFangShi),
                    '项目经理': res.data.projectManagerName,
                    '联系电话': res.data.lianXiRenPhone,
                }
                this.config[3].options.data = {
                    '招标人': res.data.zbrName,
                    '招标人代码': res.data.zbrBH,
                }
                this.config[4].options.data = res.data.zbrList.map((t) => ({
                    '中标人': t.tbrName,
                    '中标人代码': t.tbrBH,
                    '合同编号': t.heTongBH,
                    '合同金额': t.htJinE,
                    '合同签署时间': this.$util.timeFormatter(t.qianShuTime),
                }))
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
